//Enter HTML strings for .help content with tips for evaluating each body site, 
//which will appear in the /evaluate-abiltiies/physical/indepth view
//https://stackoverflow.com/questions/68385182/react-static-images-sometimes-importing-image-path-sometimes-as-base64
//the smaller ones import as base64, and they don't display in the Modal
//Not sure what I can do about this.  See LearnMoreModal for attempts at this.
//https://stackoverflow.com/questions/44154939/load-local-images-in-react-js
//https://stackoverflow.com/questions/34867769/passing-html-img-components-as-a-parameter-property-into-li-tags-with-react
//https://daveceddia.com/react-image-tag/
//aha, it does work to put the image in /public. Let's make sure that works when deployed as well.

const UE_HELP = `
<div>Upper Extremity is a very broad category -- you might start there when you don't know much about your client's specific function yet.</div>
<br />
<div>Here are some suggestions for movements to look at:</div>
<div>
  <ul>
    <li>raise and lower arms</li>
    <li>bend / straighten arms</li>
    <li>flex / extend wrists</li>
  </ul>
</div>

<div>Do you notice any of the following:</div>
<div>
  <ul>
    <li>One side more functional than the other?</li>
    <li>Spasticity?</li>
    <li>High or low muscle tone?</li>
    <li>Fatigue?</li>
    <li>Pain?</li>
    <li>Limited range?</li>
  </ul>
</div>
<div>
  <p>
  Note that even with limited to no finger function, it may be possible to hit small key-sized targets, either with a typing aid or a knuckle. <small>Photos from Mason Ellis' <a href="https://www.youtube.com/watch?v=y0iRuCpUEVM" target="_blank">video</a>, by permission.</small>
  </p>
</div>
<div class="container-fluid">
  <div class="row">
    <div class="col-md-6"><figure><img class="aa-modal-image" src="/images/body-sites/typing-aid-typing-1011x529-opt.png" /></figure></div>
    <div class="col-md-6"><figure><img class="aa-modal-image" src="/images/body-sites/knuckle-typing-998x535-opt.png" /></figure></div>
  </div>
</div>
<div>You might also take a look at the help for the specific UE sites, like finger, hand, etc.</div>
`;

const FINGER_HELP = `
<p>Here's a short video about movements for hand and finger access:</p>
<div style="padding:70% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/827648519?h=2fe2a50419&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="eval-abilities-hand-fingers"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
<br />
<div>Consider which fingers have the following movements available, at what level of force and control:<div>
<div>
  <ul>
    <li>Flexion and extension</li>
    <li>Abduction and adduction, plus thumb opposition</li>
  </ul>
</div>
<div>Does forearm support or position make a difference? e.g., a pronated forearm on armrest vs. neutral forearm</div>
`;
const HAND_HELP = `
  <p>Here's a short video about movements for hand and finger access:</p>
  <div style="padding:70% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/827648519?h=2fe2a50419&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="eval-abilities-hand-fingers"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
  <br />
  <div>Some considerations for hand movement:</div>
  <div>
  <ul>
    <li>Fisted gross upper extremity movement</li>
    <li>Hit a target with a knuckle (perhaps with neutral or partly supinated forearm)</li>
    <li>Hit a target using a typing cuff or Wanchik writer</li>
    <li>Note how many different targets, at what size and distance, can be hit consistently</li>
  </ul>
</div>
`;
const ELBOW_HELP = `
<div>Elbow movement is most often used for switch access. Movements to consider include:</div>
<div>
  <ul>
    <li>Outward movement (away from midline, like a chicken wing)</li>
    <li>Backward movement (e.g., slide forearm back along armrest)</li>
  </ul>
</div>
<p>Here's a short video about movements for elbow access:</p>
<div style="padding:70% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/850625782?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="eval-abilities-elbow"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
`;
const SHOULDER_HELP = `
<div>
  <p>Shoulder movement can be captured and used as an access method. Consider the following:</p>
  <ol>
    <li>Before assessing the shoulder, observe your client's seating system and postural supports. Be sure your client is well-supported, relaxed, and comfortable.</li>
    <li>Ask your client to show you how they move their shoulder(s).</li>
      <ul>
        <li>Notice any muscle activation or movement</li>
        <li>Typically, individuals will shrug the should, protract the shoulder blade to move the shoulder anteriorly, or retract the shoulder blade to move the shoulder posteriorly. (See photos below)</li>
        <li>Be sure to assess the movements with the client in different positions and with various gravity demands.</li>
      </ul>
  </ol>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-md-6"><figure><img class="aa-modal-image" src="/images/body-sites/shoulder-shrug-222x245-opt.png" /></figure></div>
    <div class="col-md-6">
      <figure>
        <img class="aa-modal-image" src="/images/body-sites/shoulder-2-444x283-opt.png" />
        <figcaption><small>Image by Osteomyoamare, via Wikimedia Commons</small></figcaption>
      </figure>
    </div>
  </div>
</div>

`;

const LE_HELP = `
<div>
  <p>Lower extremity movement may be a viable access method. Consider the following:</p>
  <ol>
    <li>Before beginning, observe your client's seating system and postural supports. Be sure your client is well-supported, relaxed, and comfortable.</li>
    <li>Ask your client to show you how they can move their leg(s).</li>
      <ul>
        <li>Observe the types of movements they can produce</li>
        <li>This may include kicking or lifting their leg while seated (see photos below)</li>
        <li>Explore ways you can capture the movement to use for access
        <li>Make sure your access solution allows your client to return to a fully resting position without activating their switch or AAC device</li>
      </ul>
  </ol>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-md-5">
      <figure>
        <img class="aa-modal-image" src="/images/body-sites/Flexion_Extension_Leg-2.png" />
        <figcaption><small>Image by Osteomyoamare, via Wikimedia Commons</small></figcaption>
      </figure>
    </div>
    <div class="col-md-7"><figure><img class="aa-modal-image" src="/images/body-sites/le-lift-681x522-opt.png" /></figure></div>
  </div>
</div>
`;

const TOE_FOOT_HELP = `
<div>
  <p>Toe and foot movements can be a useful access method when other consistent movements aren't available. Consider the following:</p>
  <ol>
    <li>Before beginning, be sure your client is well-supported, relaxed, and comfortable. Check seating and postural supports.</li>
    <li>Ask your client to show you how they move their feet. Give them a target to reach for.</li>
      <ul>
        <li>Notice any muscle activation or movement</li>
        <li>Look for consistent plantar flexion / dorsiflexion, and inversion / eversion (See photos below)</li>
        <li>Note that splints and shoes can impede movement due to rigidity, size, and weight</li>
      </ul>
  </ol>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-md-6">
      <figure>
        <img class="aa-modal-image" src="/images/body-sites/Plantarflexion_dorsiflexion-343x383.png" />
        <figcaption><small>Image by Osteomyoamare, via Wikimedia Commons</small></figcaption>
      </figure>
    </div>
    <div class="col-md-6"><figure><img class="aa-modal-image" src="/images/body-sites/foot-eversion-450x293-opt.png" /></figure></div>
  </div>
</div>

`;
// <div class="col-md-6"><figure><img class="aa-modal-image" src="/images/body-sites/foot-flexion-445x299-opt.png" /></figure></div>


const EYE_HELP = `
  <div>When assessing eye movement for <strong>access to computers and speech-generating devices</strong>, consider the following:</div>
  <div>
  <ul>
    <li>It can be difficult to determine if someone will or will not be successful using eye-tracking access technology without actually trying it out.</li>
    <li>Some eye-tracking devices incorporate software that has been specially designed to accommodate certain eye motor control issues (e.g., ptosis or eye lid droop). It may be helpful to talk to different eye-tracking technology manufacturers if these kinds of issues are present and trials with the technology you have easy access to have not been successful.</li>
    <li>There are a range of selection methods that can be paired with eye-tracking including: dwell, eye-blink, and using an external switch if another physical access method is present.</li>
    <li>Eye-tracking can initially be very fatiguing for some as you are required to use your eyes in a way that is not natural.</li>
    <li>It may be good to start out with larger targets or a limited number before progressing onto larger displays or accessing alphabet layouts to improve the chances of initial success.</li>
    <li>See <a href="https://www.callscotland.org.uk/information/eye-gaze/" target="_blank">CALL Scotland's eye gaze page</a> for more on using eye gaze technology.</li>
    <li>CALL also has a useful <a href="https://www.callscotland.org.uk/assets/files/eye-gaze-setup-guide.pdf" target="_blank">Eye Gaze Setup Guide</a>.</li> 
  </ul>
</div>
<div>When assessing eye movement for <strong>low tech signaling/access</strong>, consider the following:</div>
<div>
<ul>
  <li>Eye movement to a target (e.g., looking at yes/no communication symbols) might be easier for some than using eye blinks. Blinks are reflexive and can be difficult to interpret.</li>
  <li>For those with severe brainstem impairment, vertical or up/down eye movement may be preserved.</li>
  <li>If eye blinks are your only/best option, eye blinks that vary in terms of length and number may be helpful (e.g., long blink for yes, two rapid blinks for no).</li>
  <li>Keep in mind that eye movements and eye blinks can be combined. For example, an individual may use eye gaze / movement with a communication board and then may use eye blinks for yes / no confirmation of targets.</li>
  <li>Be mindful of any field-cuts and ensure that anything the individual needs to see is in their preserved field of vision. Consulting with an Occupational Therapist and/or neuro-optometrist can be helpful.</li>
  <li><a href="https://assistivetech.barnsleyhospital.nhs.uk/resource/eyelink-communication-boards/" target="_blank">Eye-linking</a> may be easier for some as it only requires the individual to fixate on and follow a target. However, this technique often requires extensive communication partner training.</li>
  <li>Using your eyes for all your communication needs can be very fatiguing - be sure to give individuals rest breaks and time between questions / answers.</li>
  <li>See <a href="https://amyandpals.com/aac-methods-low-tech" target="_blank">Amy & pALS page</a> for more on using eye movement for low tech communication.</li>
</ul>
</div>
`;

const LIP_HELP = `
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4"><figure><img class="aa-modal-image" src="/images/body-sites/sip-puff-280x210-opt.png" /></figure></div>
      <div class="col-md-8">
      <p>Some individuals may be candidates for <strong>sip-and-puff (pneumatic) switches</strong>. It’s important to remember that most sip-and-puff switches only require slight intra-oral pressure (not an actual sip and puff of the breath). The most important aspect that impacts successful use of a sip-and-puff switch is the ability to make a tight seal with the lips which allows for the intra-oral pressure build up required to activate the switch.</p>
      </div>
    </div>
    <br />
    <div><strong>Lip movements</strong> could be used as a low/no-tech signaling method or can be used to access a light touch, taction, leaf, or wobble switch. Lip movements to look for include the following:</div>
    <ul>
      <li>Smile/frown</li>
      <li>Puckering</li>
      <li>Pressing lips together or pursing lips</li>
      <li>Smirk to one side or the other</li>
      <li>Smacking or opening/closing lips</li>
    </ul>
    <div><strong>Tongue movements</strong> can be used to access a tongue switch or wobble switch. Some tongue movements to look for include the following:</div>
    <ul>
      <li>Tongue out</li>
      <li>Left/right</li>
      <li>Up/down</li>
      <li>Tongue clicks</li>
      <li>Touching upper/lower teeth with tongue</li>
    </ul>
    <div class="row">
      <p>
      <small>Photo by permission of <a href="https://orin.com/" target="_blank">Origin Instruments</a></small>
      </p>
    </div>

  </div>
`;

const CHIN_HELP = `
<div>
  <p>The chin may be an option for clients to operate a joystick and/or activate a switch. Consider the following:</p>
  <ol>
    <li>Before beginning, be sure your client is well-supported, relaxed, and comfortable. Check seating and postural supports.</li>
    <li>Ask your client to show you how they can move their chin.</li>
    <ul>
      <li>Notice any muscle activation or movement - this may include a combination of neck and jaw movements</li>
      <li>For joystick access, look for consistent movements representing forward, back, left, and right</li>
      <li>For switch access, just one consistent movement is needed per switch location</li>
    </ul>
    <li>Watch out for safety issues - spasticity or poor seating / positioning can place your client at risk of injury when using a mount for ching access.</li>
    <ul>
      <li>Work with your seating / positioning specialist as need to optimize safetys</li>
      <li>Consider the mounting strategies below as you explore chin access</li>
    </ul>
  </ol>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-md-6">
      <figure>
        <img class="aa-modal-image" src="/images/body-sites/chin-switch2-438x549-opt.png" />
        <figcaption>Two switches for chin and cheek</figcaption>
      </figure>
    </div>
    <div class="col-md-6">
      <figure>
        <img class="aa-modal-image" src="/images/body-sites/chin-js-1-381x391-opt.png" />
        <figcaption>Chair-mounted joystick</figcaption>
      </figure>
    </div>
  </div>
  <div class="row">
    <p>
      <small>Photo by permission of <a href="https://store.rjcooper.com/" target="_blank">RJ Cooper & Associates</a></small>
    </p>
  </div>
</div>
`;

const BREATH_HELP = `
  <div class="container-fluid">
  <div class="row">
    <div class="col-md-4"><figure><img class="aa-modal-image" src="/images/body-sites/puff-switch-photo-349x292-opt.png" /></figure></div>
    <div class="col-md-8">
    <p>Breath switches require the individuals to puff breath onto the activation surface of the switch. An example is the puff switch available from Glassouse.</p>
    </div>
  </div>
  <div class="row">
    <p>
      <small>Photo by permission of <a href="https://www.glassouse.com/" target="_blank">Glassouse</a></small>
    </p>
  </div>

  </div>
`;
const CLEAR_SPEECH_HELP = `
  <div>Here are some considerations when looking at speech recognition for an individual with fairly clear speech:</div>
  <div>
    <ul>
      <li>Microphone type and quality may impact results</li>
      <li>Be cognizant of impact of external noise on recognition of clear speech (e.g., ventilator, wound relief beds)</li>
      <li>Respiratory status may impact ability to use continuous strings of speech </li>
    </ul>
  </div>
`;
const DYS_SPEECH_HELP = `
  <div>Here are some considerations when looking at speech recognition for an individual with dysarthric speech:</div>
  <div>
    <ul>
      <li>Microphone type and quality may impact results</li>
      <li>Not all speech recognition systems manage dysarthric speech equally- trialing different software options may result in successful results</li>
      <li>Using speech for limited functions may be more successful (e.g., speech only for mouse commands or reduced command sets)</li>
      <li>See <a href="https://sites.research.google/relate/" target="_blank">Google's Project Relate</a> for info about an Android app being developed for recognizing non-standard speech</li>
    </ul>
  </div>
`;
const VOCAL_SOUND_HELP = `
<div class="container-fluid">
  <div class="row">
    <div class="col-md-4"><figure><img class="aa-modal-image" src="/images/body-sites/voice-switch-photo-342x388-opt.png" /></figure></div>
    <div class="col-md-8">
      <p>For those who have control over sounds / voicing, switches activated with sound or voice may be an access option, if full speech recognition is unsuccessful.</p>
      <p>Ensure that the individual has consistent and reliable control of eliciting sounds / voicing.</p>
      <p>The image shows a sound-activated switch available from Enabling Devices.<p>
    </div>
  </div>
  <div class="row">
    <p>
      <small>Photo by permission of <a href="https://www.enablingdevices.com/" target="_blank">Enabling Devices</a></small>
    </p>
  </div>
</div>
`;

// <div></div>
//   <ul>
//   <li></li>
// </ul>

const HEAD_HELP = `
<p>Here's a short video about movements for head access:</p>
<div style="padding:70% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/827366597?h=1b3ec1a624&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="eval-abilities-head"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
<br />
<div>Consider all types of head movement:</div>
<div>
  <ul>
    <li>Rotation (as when shaking head to say No), both left and right </li>
    <li>Nodding, both up and down (neck extension and flexion)</li>
    <li>Tilting, both left and right (lateral bend of the neck)</li>
  </ul>
</div>
<div>Note how many different movements are available and the control of each, compared to what different input devices require. For example:</div>
<div>
  <ul>
    <li>Using a typical head-controlled mouse requires good control of rotation as well as neck extension/flexion.</li>
    <li>Using a single switch has fewer motor demands, generally requiring one repeatable motion with a consistent level of force.  With two such motions, you could use two switches, and so on.</li>
  </ul>
</div>
`;
const FACIAL_HELP = `
<p>Here's a short video about assessing facial movements, primarily for switch or low/no-tech access:</p>
<div style="padding:70% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/827366571?h=8319fe4915&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="evaluate-abilities-facial"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
`
const KNEE_HELP = `
<p>Here's a short video about movements for knee access:</p>
<div style="padding:70% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/807618568?h=0ee21eadfc&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="leg-knee-eval-abilities.mp4"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
`;

export const BODYSITE_BUTTON_GROUPS = [ 
  {
    legend: 'Upper Extremities',
    buttons: [
      {
        value: 'left-ue',
        label: 'L Upper Extremity',
        moreInfo: '',
        help: UE_HELP
      },
      {
        value: 'left-finger',
        label: 'L Finger(s)',
        moreInfo: '',
        help: FINGER_HELP
      },
      {
        value: 'left-hand',
        label: 'L Hand',
        moreInfo: '',
        help: HAND_HELP
      },
      {
        value: 'left-elbow',
        label: 'L Elbow',
        moreInfo: '',
        help: ELBOW_HELP
      },
      {
        value: 'left-shoulder',
        label: 'L Shoulder',
        moreInfo: '',
        help: SHOULDER_HELP
      },
      {
        value: 'right-ue',
        label: 'R Upper Extremity',
        moreInfo: '',
        help: UE_HELP
      },
      {
        value: 'right-finger',
        label: 'R Finger(s)',
        moreInfo: '',
        help: FINGER_HELP
      },
      {
        value: 'right-hand',
        label: 'R Hand',
        moreInfo: '',
        help: HAND_HELP
      },
      {
        value: 'right-elbow',
        label: 'R Elbow',
        moreInfo: '',
        help: ELBOW_HELP
      },
      {
        value: 'right-shoulder',
        label: 'R Shoulder',
        moreInfo: '',
        help: SHOULDER_HELP
      }
    ]
  },
  {
    legend: 'Head Area',
    buttons: [
    {
      value: 'head',
      label: 'Head',
      moreInfo: '',
      help: HEAD_HELP
    },
    {
      value: 'eyes',
      label: 'Eyes',
      moreInfo: '',
      help: EYE_HELP
    },
    {
      value: 'lip',
      label: 'Lip / tongue',
      moreInfo: '',
      help: LIP_HELP
    },
    {
      value: 'chin',
      label: 'Chin',
      moreInfo: '',
      help: CHIN_HELP
    },
    {
      value: 'breath',
      label: 'Breath',
      moreInfo: '',
      help: BREATH_HELP
    },
    {
      value: 'facial',
      label: 'Facial Movements',
      moreInfo: '',
      help: FACIAL_HELP
    }
    ]
  },
  {
    legend: 'Speech',
    buttons: [
      {
        value: 'clear-speech',
        label: 'Clearly intelligible speech',
        moreInfo: '',
        help: CLEAR_SPEECH_HELP
      },
      {
        value: 'dysarthria',
        label: 'Speech with some dysarthria',
        moreInfo: '',
        help: DYS_SPEECH_HELP
      },
      {
        value: 'sound',
        label: 'Vocal sound',
        moreInfo: '',
        help: VOCAL_SOUND_HELP
      }  
    ]
  },
  {
    legend: 'Lower Extremities',
    buttons: [
      {
        value: 'left-le',
        label: 'L Lower Extremity',
        moreInfo: '',
        help: LE_HELP
      },
      {
        value: 'left-toe',
        label: 'L Toe(s)',
        moreInfo: '',
        help: TOE_FOOT_HELP
      },
      {
        value: 'left-foot',
        label: 'L Foot',
        moreInfo: '',
        help: TOE_FOOT_HELP
      },
      {
        value: 'left-knee',
        label: 'L Knee',
        moreInfo: '',
        help: KNEE_HELP
      },
      {
        value: 'right-le',
        label: 'R Lower Extremity',
        moreInfo: '',
        help: LE_HELP
      },
      {
        value: 'right-toe',
        label: 'R Toe(s)',
        moreInfo: '',
        help: TOE_FOOT_HELP
      },
      {
        value: 'right-foot',
        label: 'R Foot',
        moreInfo: '',
        help: TOE_FOOT_HELP
      },
      {
        value: 'right-knee',
        label: 'R Knee',
        moreInfo: '',
        help: KNEE_HELP
      }
    ]
  }
];


// //(or could do result = ACTIVITY_BUTTONS.map(a => a.buttons) followed by result.flat();)
// for(let i=0; i<ACTIVITY_BUTTONS.length; i++){
//   availableBtns.push(...ACTIVITY_BUTTONS[i].buttons);
// }
export function extractBodySiteButtons(){
  let availableBtns = [];
  for(let i=0; i<BODYSITE_BUTTON_GROUPS.length; i++){
    availableBtns.push(...BODYSITE_BUTTON_GROUPS[i].buttons);
  }
  return availableBtns;
}

//takes an array of bodySite values, and returns an array of matching buttons
//if no matching buttons found, it returns an empty array
export function getBodySiteBtnsForValues( values){
  let matchingBtns = [];
  let matchingBtn = {};
  console.log("in getBtns: " + values);
  if( values){
    for( let i=0; i<values.length; i++){
      matchingBtn = getBodySiteBtnForValue(values[i]);
      if(matchingBtn){
        console.log("found one: " + JSON.stringify(matchingBtn));
        matchingBtns.push(matchingBtn);
      }
    }
  }
  return matchingBtns;
}

export function getBodySiteBtnForValue(value){
  const allBtns = extractBodySiteButtons();
  const matchingBtn = allBtns.find(btn => (value === btn.value));
  return matchingBtn; //returns undefined if no match found
  // if (matchingBtn)
  //   return matchingBtn.label;
  // else
  //   return ""; //no match found
}

export function getBodySiteLabelForValue(value){
  const allBtns = extractBodySiteButtons();
  const matchingBtn = allBtns.find(btn => (value === btn.value));
  if (matchingBtn)
    return matchingBtn.label;
  else
    return ""; //no match found
}

export function getBodySiteHelpForValue(value){
  const allBtns = extractBodySiteButtons();
  const matchingBtn = allBtns.find(btn => (value === btn.value));
  if (matchingBtn){
    if(matchingBtn.help)
      return matchingBtn.help;
  }
  else
    return ""; //no match found
}
